import { INITIAL_STATE, setTags, addTag, deleteTag, deleteTagByTeamId } from '../core'
import {
    RECEIVE_TAGS,
    RECEIVE_TAG,
    REMOVE_TAG_BY_TEAM_ID,
    REMOVE_TAG,
} from '../action_creators'

function tags(state=INITIAL_STATE.tags, action) {
    switch (action.type) {
        case RECEIVE_TAGS:
            // handle v1 actions calling "RECEIVE_TAGS" with a single tag
            if (Array.isArray(action.tags)) {
                return setTags(state, action.tags)
            } else {
                return addTag(state, action.tags)
            }
        case RECEIVE_TAG:
            return addTag(state, action.tag)
        case REMOVE_TAG:
            return deleteTag(state, action.tag)
        case REMOVE_TAG_BY_TEAM_ID:
            return deleteTagByTeamId(state, action.teamId)
        default:
            return state
    }
}

export default tags



// WEBPACK FOOTER //
// ./src/redux/reducers/tags_reducer.js